import { HttpClient } from "@angular/common/http";
import { IResult } from "app/common/interfaces";
import { AbstractService } from "app/services/abstract.service";
import { environment as env } from "../../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import PhoneAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/phone/phone.entity";
import { ICreateBusinessPartnerPhone } from "app/modules/components/business-partners/business-partner/business-partner-phone-modal/interfaces/create-business-partner-phone.interface";
import { IUpdateBusinessPartnerPhone } from "app/modules/components/business-partners/business-partner/business-partner-phone-modal/interfaces/update-business-partner-phone.interface";
const apiUrl = env.API_CONFIGURATION_URL;
const moduleName = "company_phone";

@Injectable({
  providedIn: "root",
})
export class CompanyPhoneService extends AbstractService<
PhoneAttributes,
ICreateBusinessPartnerPhone,
IUpdateBusinessPartnerPhone
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findByCompanyId(companyId: string): Observable<IResult<PhoneAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${companyId}`;
    return this.http.get<IResult<PhoneAttributes>>(API_URL);
  }
}